import { render } from "./TheProblem.vue?vue&type=template&id=3e27100c&scoped=true"
import script from "./TheProblem.vue?vue&type=script&lang=js"
export * from "./TheProblem.vue?vue&type=script&lang=js"

import "./TheProblem.vue?vue&type=style&index=0&id=3e27100c&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/1mal1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e27100c"]])

export default __exports__